import { buildDataMapContainer } from 'src/utils/handle-data';
import * as utils from './';

export const buildDetailsCardData = (resData, chartProps) => {
  const dataMapContainer = buildDataMapContainer(resData)
      const data = utils.buildChartData(dataMapContainer[0], 1209600, chartProps.chartType);
      let dataSet = [];
      let ticks = [];
      let tickDate = parseInt(Date.now()/1000 - 1209600) 
      for(let i = 1; i < 9; i++) {
        const unixInMSecs = tickDate * 1000;
        const timezoneOffsetMSecs = new Date(unixInMSecs).getTimezoneOffset() * 60000;
        const day = new Date(unixInMSecs + timezoneOffsetMSecs)
        const date = `${day.getMonth() + 1}/${day.getDate()}`
        const id = parseInt((new Date(date + `/${day.getFullYear()}`).getTime() - timezoneOffsetMSecs) / 1000)
        ticks.push(id);
        tickDate += 172800
      }
 
      dataSet = data.data.sort((a, b) => {
        return a.id - b.id
      })
      return {dataSet, ticks,};
}


// WEBPACK FOOTER //
// ./src/components/ChartCard/utils/buildDetailsCardData.js